import { createStore, applyMiddleware } from 'redux';
import { persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

import rootReducer from './root-reducer';

const initialState = {};
const middlewares = [thunk];

export const store = createStore(
    rootReducer,
    initialState,
    applyMiddleware(...middlewares),
);

export const persistor = persistStore(store);

export default { persistor, store };